import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, Renderer2, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from './core/services/api.service';
import { LanguageService } from './core/services/language.service';
import { Location } from "@angular/common";
import { environment } from 'environments/environment';
import * as moment from 'moment';
import { KbService } from './core/services/kb.service';
import { TitleService } from './core/services/title.service';

declare global {
  interface Window {
    lc_id: any;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  favIcon: HTMLLinkElement | null = null;
  language = 'en';

  constructor(
    private api: ApiService,
    private router: Router,
    private titleService: TitleService,
    private location: Location,
    private lan: LanguageService,
    public viewContainerRef: ViewContainerRef,
    private renderer: Renderer2,
    private _kbSer: KbService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.favIcon = document.querySelector("#appIcon");
    this.language = localStorage.getItem("language") || 'en';

    console.log = function () { };
    console.warn = function () { };
    console.table = function () { };

    if (localStorage.getItem('themeColor')) {
      this.api.computeColorPalette(localStorage.getItem('themeColor'), 'theme-desku')
    }
    let checkLang
    if (localStorage.getItem("language")) {
      checkLang = localStorage.getItem("language");
      if (checkLang == undefined) {
        localStorage.setItem("language", "en");
        window.location.reload();
      }
      if (checkLang == null) {
        localStorage.setItem("language", "en");
        window.location.reload();
      }
    }
    if (this.language) {
      moment.locale(this.language);
      this.lan.setLanguage(this.language);
    } else {
      this.language = "en";
      moment.locale(this.language);
      this.lan.setLanguage(this.language);
    }

    if (window.location.protocol === "http:") {
      window.location.href = window.location.href.replace("http", "https");
    }

    if (localStorage.getItem("language")) {
      this.lan.setLanguage(localStorage.getItem("language"));
    } else {
      this.lan.setLanguage("en");
    }
  }

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (window.location.hostname == environment.baseHostName) {
      localStorage.removeItem("token");
      localStorage.removeItem("currentUser");
    }

    const params = new URLSearchParams(window.location.search);
    const authToken = params.get("token");

    if (authToken) {
      params.delete("token");
      params.delete("role");
      const remainingQuery = params.toString();
      this.location.replaceState(
        this.location.path().split("?")[0],
        remainingQuery
      );
      this.router.navigateByUrl("/");
    }
  }
}
